import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { Section, SectionHeader, SectionSubTitle, SectionTitle } from '../common/SharedComponents';
import { CompanyProofsMap } from '../../constants/company-proof/CompanyProofConfig';
import Screens from '../../constants/routing/Screens';
const StyledSection = styled(Section).withConfig({
  displayName: "CompanyProof__StyledSection",
  componentId: "sc-1wyfs9l-0"
})(["", ";"], props => props.shouldHideMobile ? `  ${breakpoint.tablet(_t || (_t = _` display: none`))}` : undefined);
const IconGridItem = styled.div.withConfig({
  displayName: "CompanyProof__IconGridItem",
  componentId: "sc-1wyfs9l-1"
})(["grid-column:span 4;display:flex;justify-content:center;align-items:center;&:nth-child(4){grid-row-start:2;grid-column:3 / span 4;}&:nth-child(5){grid-row-start:2;grid-column:7 / span 4;}"]);
const IconsGrid = styled.div.withConfig({
  displayName: "CompanyProof__IconsGrid",
  componentId: "sc-1wyfs9l-2"
})(["width:100%;display:grid;grid-template-columns:repeat(12,1fr);grid-row-gap:38px;"]);

const CompanyProof = ({
  tab,
  screen
}) => {
  const companyProofs = CompanyProofsMap[tab];
  return /*#__PURE__*/_jsxs(StyledSection, {
    shouldHideMobile: screen !== Screens.COMMERCE,
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.companyProof.title"
        })
      }), /*#__PURE__*/_jsx(SectionSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.companyProof.subtitle"
        })
      })]
    }), /*#__PURE__*/_jsx(IconsGrid, {
      children: companyProofs.map(company => /*#__PURE__*/_jsx(IconGridItem, {
        children: /*#__PURE__*/_jsx(UIImage, {
          src: company.icon,
          alt: company.name,
          objectFit: "contain",
          width: "110px"
        })
      }, company.name))
    })]
  });
};

export default CompanyProof;